<template>
  <div class="app-container your-page-name">
    公共模板
  </div>
</template>

<script>

export default {
  name: 'YourPageName',
  components: {},
  props: {},
  data () {
    return {}
  },
  created () {
  },
  mounted () {
  },
  activated () {
  },
  updated () {
  },
  beforeRouteUpdate (to, from, next) {
    // 在当前路由改变，但是该组件被复用时调用
    // 举例来说，对于一个带有动态参数的路径 /foo/:id，在 /foo/1 和 /foo/2 之间跳转的时候，
    // 由于会渲染同样的 Foo 组件，因此组件实例会被复用。而这个钩子就会在这个情况下被调用。
    console.log('update')
    console.log(from)
    console.log(to)
  },
  beforeRouteEnter (to, from, next) {
    console.log('enter')
    console.log(from)
    console.log(to)
    next() // 这个必须有，否则页面无法渲染
  },
  beforeRouteLeave (to, from, next) {
    console.log('leave')
    console.log(from)
    console.log(to)
  },
  methods: {},
  filters: {},
  computed: {},
  watch: {}
}
</script>

<style lang="scss" scoped>
  .your-page-name {
    font-size: 30px;
    font-weight: 600;
    color: #ccc;
    height: 400px;
    text-align: center;
  }
</style>
